// GENERATED by npm run generate-graphql-operations
const RemoveFromLibrary = 'mutation RemoveFromLibraryWeb($pandoraId: String!) {   uncollect(ids: [$pandoraId]) {     status   } } ';
export default RemoveFromLibrary;
